import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { storeToken } from '../../lib/api';
import { clearCache } from '../../lib/persist';

/** Clears the local session token, query cache and persisted offline cache, then navigates away. */
export function useClearLocalSession() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return useCallback(
    async (to: '/login' | '/signup') => {
      try {
        await storeToken(null);
      } catch {
        /* ignore */
      }
      qc.clear();
      try {
        await clearCache();
      } catch {
        /* ignore */
      }
      navigate(to, { replace: true });
    },
    [qc, navigate],
  );
}
